import { LinearProgress } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { Fragment, useMemo } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import SimpleAlert from "../../../components/display/SimpleAlert";
import { APPOINTMENT_BIOMETRICS } from "../../../enums/ApiPaths";
import { APPOINTMENT_BIOMETRICS_DATA } from "../../../enums/QueryKeys";
import { fetchAppointmentBiometrics } from "../../../enums/queryFunction/Fetch";
import useUser from "../../../hooks/useUser";
import BiometricsForm from "./BiometricsForm";
import BiometricsView from "./BiometricsView";
export default function AppointmentBiometrics({ showForm = true }) {
  const methods = useForm();
  const { id } = useParams();
  const { roles } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: [APPOINTMENT_BIOMETRICS_DATA + id],
    queryFn: () => fetchAppointmentBiometrics(id),
    staleTime: Infinity,
  });

  const biometrics = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((biometrics) => (
        <BiometricsView
          key={biometrics?.id}
          data={biometrics}
          queryKey={APPOINTMENT_BIOMETRICS_DATA}
          apiKey={APPOINTMENT_BIOMETRICS}
          id={id}
        />
      ));
    } else if (data) {
      return (
        <BiometricsView
          key={data?.id}
          data={data}
          queryKey={APPOINTMENT_BIOMETRICS_DATA}
          apiKey={APPOINTMENT_BIOMETRICS}
          id={id}
        />
      );
    } else {
      return null;
    }
  }, [data, id]);

  if (isLoading) {
    return <LinearProgress />;
  }

  return (
    <Fragment>
      {roles?.user || !showForm ? null : (
        <FormProvider {...methods}>
          <BiometricsForm
            queryKey={APPOINTMENT_BIOMETRICS_DATA}
            apiKey={APPOINTMENT_BIOMETRICS}
            id={id}
          />
        </FormProvider>
      )}
      {error ? (
        <SimpleAlert
          severity={"error"}
          message={"ErrorFetchingBiometricsList"}
          paper={true}
        />
      ) : biometrics?.length == 0 || !biometrics ? (
        <SimpleAlert
          paper={true}
          severity={"info"}
          message={"NoBiometricsCurrentlyAvailable"}
        />
      ) : (
        biometrics
      )}
    </Fragment>
  );
}
